import React from "react";
import styles from "./Staff.module.scss";
function Text({ title, subTitle }) {
  return (
    <div className={styles.textBox}>
      <div
        className={styles.title}
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />

      <div
        className={styles.text}
        dangerouslySetInnerHTML={{
          __html: subTitle,
        }}
      />
    </div>
  );
}

export default Text;
